export default __webpack_public_path__ + "static/media/session-teacher.baed5632.svg";